import { PesquisaSatisfacaoSiteComponent } from 'app/pesquisa-satisfacao-site/pesquisa-satisfacao-site.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PageTitleService } from 'app/core/page-title/page-title.service';
import { MensagensService } from 'app/services/mensagens.service';
import { SiteService } from 'app/services/site.service';
import { ValidadorService } from 'app/services/validador.service';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment';
import { AcessoRestritoSiteService } from 'app/services/acesso-restrito.service';
import Swal, { SweetAlertOptions } from 'sweetalert2';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/takeWhile';
import 'rxjs/add/observable/timer';
import { MinhaAreaSiteComponent } from 'app/minha-area-site/minha-area-site.component';
import { EventosService } from '../services/eventos.service';

@Component({
  selector: 'app-extrato-atas',
  templateUrl: './extrato-atas.component.html',
  styleUrls: ['./extrato-atas.component.css']
})
export class ExtratoAtasComponent implements OnInit, OnDestroy {
  idPensionista = 0;
  nomeUsuario = '';
  idSelecionado = 0;
  idAtaSelecionado = 0;
  conselhos: any[] = [];
  atas: any[] = [];
  inSpinner = false;
  @ViewChild(MinhaAreaSiteComponent) principal: MinhaAreaSiteComponent;
  cpf = '';

  constructor(
    private pageTitleService: PageTitleService,
    private formBuilder: FormBuilder,
    public validadorService: ValidadorService,
    public acessoRestritoSiteService: AcessoRestritoSiteService,
    public servico: SiteService,
    private eventosService: EventosService,
    public router: Router,
    private modalService: NgbModal,
    public mensagensService: MensagensService
  ) {
    this.pageTitleService.setTitle('Infomes');
    /* Page subTitle */
    this.pageTitleService.setSubTitle('');
    const usuario = JSON.parse(localStorage.getItem('localUsuarioDerminas'));
    this.cpf = usuario.cpf;
    if (!!usuario) {

      this.nomeUsuario = usuario.nomeUsuario;
      this.idPensionista = usuario.idPensionista;

    } else {
      this.router.navigate(['acesso-restrito']);
    }
  }

  ngOnInit(): void {
    this.acessoRestritoSiteService.conselhos()
      .pipe(finalize(() => {
      }))
      .subscribe(result => {
        this.conselhos = result;
      },
        err => {
          const erro = this.mensagensService.recuperarMensagemErro(err);
          this.mensagensService.Error('Ocorreu um Erro!', erro);
        });
  }

  ngOnDestroy() {
  }

  sair() {
    this.eventosService.logout();
    localStorage.removeItem('localUsuarioDerminas');
    this.router.navigate(['acesso-restrito']);
  }

  exibirAtas(conselho: any) {
    this.idSelecionado = conselho.idConselho;
    this.idAtaSelecionado = 0;
    this.acessoRestritoSiteService.atas(conselho.idConselho)
      .pipe(finalize(() => {
      }))
      .subscribe(result => {
        this.atas = result;
      },
        err => {
          const erro = this.mensagensService.recuperarMensagemErro(err);
          this.mensagensService.Error('Ocorreu um Erro!', erro);
        });
  }

  baixarAta(ata: any) {
    this.idAtaSelecionado = ata.idAta;
    this.inSpinner = true;
    this.servico.download(ata.link, 'atas')
      .pipe(finalize(() => {
        this.inSpinner = false;
      })).
      subscribe(response => {
        //this.mensagensService.openBase64FileInNewTab(response.base64, ata.link);
        window.open(response.url, '_blank')
      },
        err => {
          this.inSpinner = false;
          const erro = this.mensagensService.recuperarMensagemErro(err);
        });
  }

  voltar() {
    this.principal.voltando();
  }

}
